import http from "../http-common";

const getLatest = async () => {
  return await http
    .get("/api/changelog/latest")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const getChangelogs = async (skip = 0, take = 5) => {
  return await http
    .get("/api/changelog/changelogs", { params: { skip, take } })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
export default {
  getLatest,
  getChangelogs,
};
